import ContactPageComponent from "../components/ContactComponent"
import FooterComponent from "../components/FooterComponent"
import HeaderComponent from "../components/HeaderComponent"

const ContactPage = () => {
    return (
        <>
            <HeaderComponent/>
            <ContactPageComponent/>
            <FooterComponent/>
        </>
    )
}

export default ContactPage